module.exports = __webpack_public_path__ + "img/8.3a5b13ce.jpg";